import React, { useCallback, useEffect, useState, createRef, forwardRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { useIntl } from 'react-intl';
import { api } from '../../../../../../api';
import './styles.scss';

const EditUserPasswordModal = ({ setError, data, onClose }) => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const { formatMessage: f } = useIntl();

  let passwordInput = createRef();

  const hasAllRequiredFields = () =>
    password.length !== 0 &&
    passwordConfirmation.length !== 0;

  const generateRequiredFieldsMessage = () => {
    const errorFields = [];
    if (password.length === 0) errorFields.push("senha");
    if (passwordConfirmation.length === 0)
      errorFields.push("confirmação de senha");

    return (
      "Informe " +
      errorFields.reduce(
        (prev, field, index) =>
          prev + (index === errorFields.length - 1 ? " e " : ", ") + field
      )
    );
  };
  
  const handleUserUpdatePassword = e => {
    e.preventDefault();

    if (!hasAllRequiredFields()) {
      setErrorMessage(generateRequiredFieldsMessage());
    } else if (password !== passwordConfirmation) {
      setErrorMessage(f({ id: "senhas-diferentes" }));
    } else {
      setLoading(true);
      api
        .post("/users/reset_password", {
          email: email,
          password: password
        })
        .then(res => {
          alert('Senha Atualizada com sucesso!');
          onClose();
        })
        .catch(error => {
          setErrorMessage(error.response.data.message || f({ id: "erro-api" }));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const getUserInfo = useCallback(() => {
    api.get(`/users/get_user_all?id=${data}`)
      .then(({data: response }) => {

        if(response){
          setName(response.PessoaFisica.nome ? response.PessoaFisica.nome : null);
          setEmail(response.User.username ? response.User.username : null);
        }

        setLoading(false);
      })
      .catch(() => {
        setError(formatMessage({ id: "erro-api" }));
        setLoading(false);
      });
  }, [data, formatMessage, setError]);

  useEffect(() => {
    passwordInput.current && passwordInput.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getUserInfo();
  }, [getUserInfo]);

  return (
    <div className="modal edit-user-password-modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <div className="modal-card-title">
            {formatMessage({ id: "alterar-senha" })}
          </div>
        </header>
        <section className="modal-card-body">
          {errorMessage ? (
            <div className="auth-error-message">{errorMessage}</div>
          ) : (
            <div className="auth-error-message-spacer"></div>
          )}

          <div className="input-container">
            <input
              type="text"
              name="name"
              placeholder={f({ id: "nome" })}
              value={name}
              disabled
            />
            <label htmlFor="name">{f({ id: "nome" })}</label>
          </div>

          <div className="input-container">
            <input
              type="email"
              name="email"
              placeholder="E-mail"
              value={email}
              disabled
            />
            <label htmlFor="email">E-mail</label>
          </div>

          <div className="input-container">
            <input
              ref={passwordInput}
              type="password"
              name="password"
              autoComplete="new-password"
              placeholder={f({ id: "senha" })}
              value={password}
              required
              onChange={e => setPassword(e.target.value)}
            />
            <label htmlFor="password">{f({ id: "senha" })}</label>
          </div>

          <div className="input-container">
            <input
              className={
                passwordConfirmation.length > 0 && passwordConfirmation !== password
                  ? "error"
                  : ""
              }
              type="password"
              name="password-confirmation"
              placeholder={f({ id: "confirma-senha" })}
              value={passwordConfirmation}
              required
              onChange={e => setPasswordConfirmation(e.target.value)}
            />
            <label htmlFor="password-confirmation">
              {f({ id: "confirma-senha" })}
            </label>
          </div>

        </section>
        <footer className="modal-card-foot">
          <button
            className="button danger"
            onClick={onClose}
          >
            {formatMessage({ id: "cancelar" })}
          </button>

          <button
            className={`button primary ${loading ? "is-loading" : ""}`}
            disabled={!hasAllRequiredFields()}
            onClick={handleUserUpdatePassword}
          >
            {formatMessage({ id: "atualizar-cadastro" })}
          </button>
        </footer>
      </div>
    </div>
  )
}

const DatePickerCustom = forwardRef((props, ref) => (
  <input className="date-picker-custom" {...props} ref={ref} />
));

export default EditUserPasswordModal;